import React, { useEffect, useState } from 'react';
import { useData } from './AuthContext';
import './MenuModal.css';
import LoginMenuModal from './LoginMenuModal';
import HistoryModal from './HistoryModal';

const MenuModal = ({ isOpen, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isFadingIn, setIsFadingIn] = useState(false);
  const [isLoginMenuOpen, setIsLoginMenuOpen] = useState(false);
  const [isHistoryMenuOpen, setIsHistoryMenuOpen] = useState(false);

  // use savedCalculations from context
  const { isLoggedIn, logout } = useData();

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      const timeout = setTimeout(() => setIsFadingIn(true), 10);
      return () => clearTimeout(timeout);
    } else {
      setIsFadingIn(false);
      const timeout = setTimeout(() => {
        setIsVisible(false);
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      }, 300);
      return () => clearTimeout(timeout);
    }
  }, [isOpen]);

  const handleQuoteHistoryClick = () => {
    setIsHistoryMenuOpen(true);
  };;

  if (!isVisible) return null;

  const toggleLoginMenu = () => setIsLoginMenuOpen(!isLoginMenuOpen);

  return (
    <div className={`menu-modal-overlay ${isFadingIn ? 'fade-in' : 'fade-out'}`}>
      <LoginMenuModal isOpen={isLoginMenuOpen} onClose={toggleLoginMenu} />
      <HistoryModal isOpen={isHistoryMenuOpen} onClose={() => setIsHistoryMenuOpen(false)} />
      <div className="menu-modal">
        <button className="close-button" onClick={onClose}>&times;</button>
        <ul className="menu-links">
          {isLoggedIn ? (
            <li className='page-link'><a onClick={() => logout()}>Logout</a></li>
          ) : (
            <li className='page-link'><a onClick={() => toggleLoginMenu()}>Login</a></li>
          )}
          <li className='page-link'><a href="https://mannokbuild.com/insulation-boards/floor-insulation/">Floor Insulation</a></li>
          <li className='page-link'><a href="https://mannokbuild.com/insulation-boards/wall-insulation/">Wall Insulation</a></li>
          <li className='page-link'><a href="https://mannokbuild.com/insulation-boards/pitched-roof/">Pitched Roof Insulation</a></li>
          <li className='page-link'><a href="https://mannokbuild.com/insulation-boards/flat-roof/">Flat Roof Insulation</a></li>
          <li className='page-link'>
            <a href="#" onClick={handleQuoteHistoryClick}>Calculation History</a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default MenuModal;
